<template>
    <div class="cta-image-area_two cta-image-bg-03 section-space--ptb_90">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="cta-image__content text-center">
                        <h3 class="cta-image__title mb-20">{{ $t('baslamayahazirmisin') }}</h3> 
                        <div class="cta-image__text mb-40">{{ $t('slogan2') }}</div>
                        <router-link to="/contacts" class="ht-btn ht-btn-md">{{ $t('simdidene') }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {
        name: 'CtaTwo',
    }
</script>